import styled from 'styled-components';
import {alignStart, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {getSpacing, getToken, getFontSize, responsive, getFontWeight} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../../../globalVariables/GlobalVariables';

export const section = styled.div`
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    border-radius: 10px;
    background: ${getToken('color.bg.surface.default')};
    border: 1px solid ${getToken('color.brand.main')};
    margin-block: ${getSpacing('spaceXl', 'desktop')};
    ${mobileMedia}{
        padding: ${getSpacing('spaceSm')};
    }
`;
export const sectionContent = styled.div`
    ${dFlexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceMd', 'desktop')};
    width: 100%;
    max-height: 200px;
    flex-wrap: wrap;
    margin-block: ${getSpacing('spaceXl', 'desktop')};

`;
export const sectionTitle = styled.h3`
    ${responsive(getFontSize('body'), 'font-size')};
    ${responsive(getFontWeight('semibold'), 'font-weight')};
    color: ${getToken('color.text.primary')};
`;

export const detailItem = styled.div`
`;

export const label = styled.div`
    ${responsive(getFontSize('body'), 'font-size')};
    ${responsive(getFontWeight('semibold'), 'font-weight')};
    color: ${getToken('color.text.secondary')};
    min-width: 150px;
`;

export const value = styled.div`
    ${responsive(getFontSize('body'), 'font-size')};
    color: ${getToken('color.text.primary')};
`;

